import BaseServiceHttp from '../baseService'
class Bibliotecarios extends BaseServiceHttp {
  constructor(id) {
    const resource = 'bibliotecarios'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Bibliotecarios(id)
